module.exports = __webpack_public_path__ + "socicon.944f06f5f65ef84a3a36.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/socicon/font/socicon.woff
// module id = ../../../../socicon/font/socicon.woff
// module chunks = styles